import { render, staticRenderFns } from "./qs2-08.vue?vue&type=template&id=1fb1c1ec&scoped=true&"
import script from "./qs2-08.vue?vue&type=script&lang=js&"
export * from "./qs2-08.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb1c1ec",
  null
  
)

export default component.exports